/* oxlint-disable i18next/no-literal-string -- DEV ONLY preview, never shipped */
import type { FC } from 'react';
import { StyleSheet, View } from 'react-native';
import { Button, Text } from 'react-native-paper';

import { DynamicHeightCardCarousel } from '@/features/start/components/components/DynamicHeightCardCarousel';
import { FirstStepsCard } from '@/features/start/components/header/FirstStepsCard';
import { useTutorial } from '@/features/tutorial/providers/useTutorial';
import { useTutorialStore } from '@/features/tutorial/store/tutorialStore';
import { StateView } from '@/shared/components/state-view/StateView';
import { useAppTheme } from '@/styles/hooks/useAppTheme';

const styles = StyleSheet.create({
  content: { paddingVertical: 24, gap: 16 },
  caption: { marginHorizontal: 12 },
  button: { alignSelf: 'center' }
});

/**
 * DEV ONLY. Renders the real start card and the real tour outside of the
 * authenticated area so both can be reviewed without a backend login.
 * Registered in AppRouting only when __DEV__ is true.
 */
export const TourPreviewScreen: FC = () => {
  const theme = useAppTheme();
  const { present, cardVisible } = useTutorial();

  return (
    <StateView backgroundColor={theme.colors.surface}>
      <View style={styles.content}>
        <Text variant="titleMedium" style={styles.caption}>
          Vorschau: Kachel auf der Startseite
        </Text>
        {cardVisible ? (
          <DynamicHeightCardCarousel>
            <FirstStepsCard />
          </DynamicHeightCardCarousel>
        ) : (
          <>
            <Text style={styles.caption}>
              Kachel ausgeblendet (Tour abgeschlossen oder weggeklickt).
            </Text>
            <Button
              mode="outlined"
              style={styles.button}
              onPress={() =>
                useTutorialStore.setState({
                  cardVisible: true,
                  completed: false
                })
              }
            >
              Kachel wieder einblenden
            </Button>
          </>
        )}
        <Text variant="titleMedium" style={styles.caption}>
          Vorschau: Tour
        </Text>
        <Button mode="contained" style={styles.button} onPress={present}>
          Tour öffnen
        </Button>
      </View>
    </StateView>
  );
};
